"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_final_form_arrays_1 = require("react-final-form-arrays");
const FormContexts_1 = require("../Contexts/FormContexts");
const lodash_1 = __importDefault(require("lodash"));
const noop = () => { };
const hasValue = (obj) => {
    if (!obj) {
        return false;
    }
    const flattenObj = lodash_1.default.flatMapDeep(obj);
    if (!flattenObj) {
        return false;
    }
    return flattenObj.some(x => x !== undefined);
};
/**
 *  The repeatable wrapper is a component which wraps any repeatable form control and manages the additional and subtraction of individual repeated form controls
 * It will also render a single item for non-repeatable form controls
 * @param controlPath The defined path of this control, as determined by final-form
 * @param controlDefinition The definition of this control. This is primarily used to determine the number of repeatable values
 * @param renderControl The render function which will be called for each item in a repeatable control
 */
const RepeatableRender = props => {
    var _a;
    const { controlMap } = (0, FormContexts_1.useControlProvider)();
    const { controlPath, controlDefinition, renderControl } = props;
    const newFields = (0, react_1.useRef)([]);
    const [newFieldsAdded, setNewFieldsAdded] = (0, react_1.useState)(false);
    if (((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.enabled) && (controlDefinition.repeats.max > 1 || controlDefinition.repeats.max < 0)) {
        const initialValuesIfNotExists = controlDefinition.repeats.min
            ? lodash_1.default.range(0, controlDefinition.repeats.min).map(() => props.defaultValue)
            : [props.defaultValue];
        return (react_1.default.createElement(react_final_form_arrays_1.FieldArray, { name: controlPath, initialValue: initialValuesIfNotExists }, ({ fields }) => {
            const handleAddClicked = () => {
                setNewFieldsAdded(true);
                setTimeout(() => {
                    fields.push(undefined);
                }, 100);
            };
            if (!newFieldsAdded) {
                fields.forEach((_field, index) => {
                    if (!newFields.current.includes(index)) {
                        newFields.current.push(index);
                    }
                });
            }
            const renderComponent = (name, index, repeatCount, items) => {
                return renderControl(Object.assign(Object.assign({}, props), { key: name, isOriginal: items.includes(index) && hasValue(fields.value[index]), controlPath: `${name}`, onAddClick: handleAddClicked, onRemoveClick: () => {
                        fields.remove(index);
                        // let itemsToDecrease = items.filter((x) => x > index);
                        // itemsToDecrease.forEach((x) => {
                        //   items[items.indexOf(x)] = x - 1;
                        // });
                        // fields.value.splice(index, 1);
                        // setVersion((prev) => prev + 1);
                    }, repeatable: true, index: index, repeatCount: repeatCount || 0, moveItems: () => {
                        // let itemsToDecrease: number[] = [];
                        // let itemsToIncrease: number[] = [];
                        // if (to > from) {
                        //   itemsToDecrease = items.filter((x) => x <= to && x > from);
                        // }
                        // if (to < from) {
                        //   itemsToIncrease = items.filter((x) => x >= to && x < from);
                        // }
                        // if (items.includes(from)) {
                        //   items[items.indexOf(from)] = to;
                        // }
                        // itemsToDecrease.forEach((x) => {
                        //   items[items.indexOf(x)] = x - 1;
                        // });
                        // itemsToIncrease.forEach((x) => {
                        //   items[items.indexOf(x)] = x + 1;
                        // });
                        // fields.move(from, to);
                    } }));
            };
            return (react_1.default.createElement(controlMap.RepeatWrapper, null, fields.map((name, index) => {
                return renderComponent(name, index, fields.length || 0, newFields.current);
            })));
        }));
    }
    else {
        return renderControl(Object.assign(Object.assign({}, props), { key: controlPath, index: 0, onAddClick: noop, onRemoveClick: noop, repeatable: false, repeatCount: 1 }));
    }
};
exports.default = react_1.default.memo(RepeatableRender);
